export default __webpack_public_path__ + "static/media/whitelist-icon.ae5a4dcc.png";